import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTitle } from '../../common/hooks';
import './NotFoundPage.scss';

const NotFoundPage: React.FC = () => {
  
  useTitle('404 - Not Found');

  return (
    <main className='not-found-page'>
      <h1>We are sorry, the page you requested cannot be found.</h1>
      <p>The URL may be misspelled or the page you're looking for is no longer available.</p>
    </main>
  );
}

export default observer(NotFoundPage);
